import { createFileRoute } from '@tanstack/react-router'
import IsaRedatoraPage from '@/pages/dashboard/isa-redatora-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/isa-redatora',
)({
  component: function IsaRedatoraRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <IsaRedatoraPage />
      </ProtectedRoute>
    )
  },
})
